module.exports = __webpack_public_path__ + "img/ewa_binczyk.8a4c39f6.png";